export default "__VITE_ASSET__5833ec8d__"